document.addEventListener('DOMContentLoaded', function() {
  var drawerForm = document.querySelector('#localization_formdrawer');
  if (drawerForm) {
    // Initialize currency selector
    var currencyDisclosure = drawerForm.querySelector('[data-disclosure-currency]');
    if (currencyDisclosure) {
      new theme.Disclosure(currencyDisclosure);
    }
    // Initialize language selector
    var localeDisclosure = drawerForm.querySelector('[data-disclosure-locale]');
    if (localeDisclosure) {
      new theme.Disclosure(localeDisclosure);
    }
  }
});

// #_product: smooth scroll then instant snap so first click matches reload/second click.
// (function () {
//   var productHash = '#_product';
//   var snapGen = 0;

//   function productAnchorScrollY() {
//     var target = document.getElementById('_product');
//     if (!target) return null;
//     var margin =
//       (parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0) +
//       (parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
//     return Math.max(0, target.getBoundingClientRect().top + window.scrollY - margin);
//   }

//   function scrollToYInstant(y) {
//     if (typeof window.scrollTo === 'function') {
//       try {
//         window.scrollTo({ top: y, left: 0, behavior: 'instant' });
//         return;
//       } catch (e) {}
//     }
//     window.scrollTo(0, y);
//   }

//   function snapExact() {
//     var y = productAnchorScrollY();
//     if (y === null) return;
//     scrollToYInstant(y);
//   }

//   function scrollToProductAnchor(smooth) {
//     var y = productAnchorScrollY();
//     if (y === null) return;
//     if (!smooth) {
//       scrollToYInstant(y);
//       return;
//     }
//     if (Math.abs(window.scrollY - y) <= 3) return;

//     var id = ++snapGen;
//     function done() {
//       if (id !== snapGen) return;
//       snapExact();
//     }

//     window.scrollTo({ top: y, left: 0, behavior: 'smooth' });

//     window.addEventListener('scrollend', function onEnd() {
//       window.removeEventListener('scrollend', onEnd);
//       done();
//     });
//     window.setTimeout(done, 700);
//   }

//   function syncHashFromLocation() {
//     return window.location.hash === productHash;
//   }

//   window.addEventListener('load', function () {
//     if (!syncHashFromLocation()) return;
//     scrollToProductAnchor(false);
//     requestAnimationFrame(function () {
//       if (syncHashFromLocation()) scrollToProductAnchor(false);
//     });
//   });
//   window.addEventListener('pageshow', function (evt) {
//     if (evt.persisted && syncHashFromLocation()) scrollToProductAnchor(false);
//   });

//   document.addEventListener(
//     'click',
//     function (evt) {
//       var a = evt.target.closest && evt.target.closest('a[href]');
//       if (!a) return;
//       try {
//         var url = new URL(a.href);
//       } catch (e) {
//         return;
//       }
//       if (url.hash !== productHash) return;
//       if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
//       if (!document.getElementById('_product')) return;
//       evt.preventDefault();
//       if (history.pushState) {
//         history.pushState(null, '', url.pathname + url.search + url.hash);
//       }
//       scrollToProductAnchor(true);
//     },
//     true
//   );
// })();